import supabase from '../config/supabaseClient';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Not authenticated');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export async function startCheckout() {
  const headers = await authHeaders();
  const res = await fetch(`${SUPABASE_URL}/functions/v1/create-checkout-session`, {
    method: 'POST',
    headers,
  });
  const body = await res.json();
  if (!res.ok) {
    const err = new Error(body?.message || body?.error || 'Checkout failed');
    err.status = res.status;
    err.code = body?.error;
    throw err;
  }
  return body;
}

export async function openBillingPortal() {
  const headers = await authHeaders();
  const res = await fetch(`${SUPABASE_URL}/functions/v1/create-portal-session`, {
    method: 'POST',
    headers,
  });
  const body = await res.json();
  if (!res.ok) {
    const err = new Error(body?.message || body?.error || 'Portal failed');
    err.status = res.status;
    err.code = body?.error;
    throw err;
  }
  return body;
}

export async function fetchSubscription(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('subscription_status,subscription_id,trial_end,current_period_start,current_period_end,price_tier,canceled_at,stripe_customer_id')
    .eq('user_id', userId)
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export function isSubscriptionActive(sub) {
  if (!sub) return false;
  return sub.subscription_status === 'active' || sub.subscription_status === 'trialing';
}

export function isTrialing(sub) {
  return sub?.subscription_status === 'trialing';
}

export function trialDaysRemaining(sub) {
  if (!isTrialing(sub) || !sub?.trial_end) return null;
  const ms = new Date(sub.trial_end).getTime() - Date.now();
  if (!Number.isFinite(ms) || ms < 0) return 0;
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}
